export const NO_CAPTCHA_REQUIRED_STATUS = 'No captcha response required by the backend';

// https://docs.hcaptcha.com/#siteverify-error-codes-table
// https://docs.hcaptcha.com/configuration/#error-codes
export const CAPTCHA_ERRORS = new Set([
  'rate-limited',
  'network-error',
  'invalid-data',
  'invalid-input-response',
  'invalid-input-secret',
  'internal-error',
  'missing-input-response',
  'missing-input-secret',
  'bad-request',
  'timeout-or-duplicate',
  'challenge-error',
]);

export const MAX_RETRY_COUNT = 3;
